import React from 'react';
import { FileText, Menu } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Header() {
  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed w-full bg-white/80 backdrop-blur-md z-50 border-b border-gray-100"
    >
      <nav className="container mx-auto px-4 py-4 flex items-center justify-between">
        <motion.div 
          className="flex items-center space-x-2"
          whileHover={{ scale: 1.05 }}
        >
          <FileText className="w-8 h-8 text-indigo-600" />
          <div className="flex flex-col">
            <span className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 
              text-transparent bg-clip-text">Resumify</span>
            <span className="text-xs text-gray-600">by Harsh Shirke</span>
          </div>
        </motion.div>
        
        <div className="hidden md:flex items-center space-x-8">
          {['Features', 'Templates', 'Pricing', 'Contact'].map((item) => (
            <motion.a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="text-gray-600 hover:text-indigo-600 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              {item}
            </motion.a>
          ))}
        </div>
        
        <button className="md:hidden">
          <Menu className="w-6 h-6 text-gray-600" />
        </button>
      </nav>
    </motion.header>
  );
}